module.exports = __webpack_public_path__ + "img/intro9.fe059f07.gif";